<template>
<div class="login-form wmin-sm-400">
    <div class="card mb-0">
        <ul class="nav nav-tabs nav-justified alpha-grey mb-0">
            <li class="nav-item">
                <router-link :to="{ name: 'auth.login' }" class="nav-link border-y-0 border-left-0 ">
                    <h6 class="my-1">
                        <i class="fas fa-house-user mr-2"></i>{{$t('Sign in')}}
                    </h6>
                </router-link>
            </li>
            <li class="nav-item">
                <router-link :to="{ name: 'auth.register' }" class="nav-link border-y-0 border-right-0 active">
                    <h6 class="my-1">
                        <i class="fas fa-book-user mr-2"></i>{{$t('Register')}}
                    </h6>
                </router-link>
            </li>
        </ul>

        <div class="tab-content card-body">
            <!-- <div class="tab-pane fade">
                <login-component></login-component>
            </div> -->
            <div class="tab-pane fade show active">
                <register-component></register-component>
            </div>
        </div>
    </div>
</div>
</template>

<script>
// import LoginComponent from './Login';
import RegisterComponent from './Register';
import VerifyComponent from './Verify';

export default {
    components: {
        // LoginComponent,
        RegisterComponent,
        VerifyComponent
    }
}
</script>



// WEBPACK FOOTER //
// src/components/central/authorization/IndexRegister.vue